import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerBlack, tannerGray, tannerSemantic } from '../colors';
import { createBreakpoints } from '@mui/system';

type MuiTab = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiTab'];
  defaultProps?: ComponentsProps['MuiTab'];
  variants?: ComponentsVariants['MuiTab'];
};

type MuiTabs = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiTabs'];
  defaultProps?: ComponentsProps['MuiTabs'];
  variants?: ComponentsVariants['MuiTabs'];
};

const breakpoints = createBreakpoints({
  values: {
    xs: 0,
    sm: 361,
    md: 768,
    lg: 960,
    xl: 1200,
  },
});

export const MuiTab: MuiTab = {
  styleOverrides: {
    root: {
      color: '#000',
      fontSize: 14,
      fontWeight: 500,
      minWidth: 50,
      textTransform: 'none',
      [breakpoints.up('sm')]: { minWidth: 50 },
      '&:focus-visible, &.Mui-focusVisible': {
        backgroundColor: tannerGray['100'],
        outline: `3px solid ${tannerSemantic.info.color}`,
        outlineOffset: '-3px',
        borderRadius: '3px',
      },
      '&:hover': {
        backgroundColor: tannerGray[50],
      },
      '&.Mui-selected': {
        color: tannerBlack,
      },
      '&:active': {
        backgroundColor: tannerGray[100],
      },
    },
    textColorInherit: {
      opacity: 1,
    },
  },
};

export const MuiTabs: MuiTabs = {
  defaultProps: {
    indicatorColor: 'primary',
  },
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${tannerGray['200']}`,
    },
    scrollButtons: {
      '&.Mui-disabled': {
        opacity: 0.3,
      },
    },
    indicator: {
      height: 4,
    },
  },
};
